finderApp.directive('niWelcome', function() {
    return {
        restrict: 'E',
        scope: true,
        link: function(scope, element, attrs) {
            scope.initTabDrop = function() {
                var selector = scope.welcome.product.sku ? '.content-header-navigation .navigation-items' : '.welcome-header-navigation .navigation-items';

                jQuery(element).find(selector).tabdrop({
                    text: Util.i18n.get('tabdropdown.more'),
                    singleText: Util.i18n.get('tabdropdown.menu'),
                    reduceWidthContainer: ['.content-header-logo', '.welcome-header-price-button-container']
                });
            };
        },
        controller: ['$scope', '$q', 'productService', function($scope, $q, productService) {
            $scope.welcome = window.welcome;

            var sku = $scope.welcome.product.sku,
                name = $scope.welcome.product.title,
                brand = $scope.welcome.product.brand,
                segmentationCategory = $scope.welcome.product.segmentationCategory,
                pathSegments = location.pathname.split('/');


            $q.when()
                .then(function() {
                    return productService.getReferencePrice($scope.welcome.product)
                        .then(function (data) {

                            var priceNode = data.price.main,
                                price = priceNode.numeric_min_price || priceNode.numeric_price,
                                discount = priceNode.numeric_save_price || 0;

                            // ecommerce funnel tracking
                            Track.pushData({ ecommerce: null });
                            Track.pushData({
                                event: "item_webtour",
                                product_type: "perpetual",
                                ecommerce: {
                                    currency: priceNode.currency,
                                    value: price,
                                    items: [
                                        {
                                            item_id: sku,
                                            item_name: name,
                                            item_version: priceNode.license,
                                            affiliation: "native instruments",
                                            item_brand: "native instruments",
                                            item_category: priceNode.item_type,
                                            item_category2: "",
                                            item_category3: "",
                                            coupon: "",
                                            discount: discount,
                                            price: price,
                                            quantity: 1
                                        }
                                    ]
                                }
                            });

                            Track.event('funnel', {
                                step: 'product',
                                products: [{
                                    productId: sku,
                                    productName: name,
                                    price: data.referencePrice,
                                    category: brand ? brand : pathSegments[3] ? pathSegments[3] : '',
                                    subCategory: segmentationCategory ? segmentationCategory : pathSegments[4] ? pathSegments[4] : ''
                                }]
                            });

                            // Disabled per request from @thomas.brandl: generates too much GA traffic
                            // Track.analyticsEvent('Product', 'Viewed', name);

                        });
                })
                .then(function() {
                    $scope.initTabDrop();
                });

        }]
    };
});